<div class="content-section">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-div">
      <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
          <div class="p-0">
            <h2 class="background_title">{{ 'INSTITUTION_MANAGEMENT.MANAGE_INSTITUTION_OR_GROUP' | translate }}</h2>
          </div>
          <div class="justify-content-end d-flex">
            <button *ngIf="(userData) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)" (click)=addInstitution() class="btn-continue-bordered-transparent-bd btn-center addInstitution separate-buttons">
                {{ 'INSTITUTION_MANAGEMENT.ADD' | translate }}
            </button>
            <button *ngIf="(userData) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)" (click)=trialInstitution() class="btn-continue-bordered-transparent-bd btn-center addInstitution">
                {{ 'INSTITUTION_MANAGEMENT.TRIAL_INSTITUTION_LIST' | translate }}
            </button>
        </div>
      </div>  
    </div>   
    <div class="container-fluid">
        <div class="row justify-content-end align-items-center mb-3">
            <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
            <a kendoTooltip tooltipClass="tooltipButton" title="{{ 'Institutions export' | translate }}" class="cursor mx-4 exportIcon" *ngIf="(userData) && (userData?.roleName.roleId == 1 || userData?.roleName.roleId == 2)"
                    (click)="exportWebKess()"> <img width="25px" height="25px" src="assets/img/svg/iconfinder_download.svg"></a>
            <kendo-excelexport [data]="dataForExcel" [fileName]="getFileName()" [filterable]="true" #excelexport>
                <kendo-excelexport-column *ngFor="let field of fieldsExcel" [field]="field" title="{{field | translate}}">
                </kendo-excelexport-column>
            </kendo-excelexport>
        </div>
        <div class="col-12 static-card">
            <bd-light-table 
            [gridData]="gridData || [] | search:searchText:['institution','countryName','groupName','bedSize','institutionName','userLicense','webKessValue']" 
            [pageInfo]="pageInfo" [fields]="fields" [actions]="actionItems" [actionsLast]=true
            [classTable]="'institutions'"></bd-light-table>
        </div>
    </div> 

  </div>
  
 


<ng-template #template class="modal-addGroup">
    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'INSTITUTION_MANAGEMENT.ADD_TO_GROUP' | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body addToGroup" data-simplebar>
        <div class="form-group">
            <input inputSanitize type="text" class="form-control search-input" [(ngModel)]="searchTextGroup" placeholder="{{ 'INSTITUTION_MANAGEMENT.SEARCH_GROUP' | translate }}" />
        </div>
        <div class="list-group lang-group">
            <a class="list-group-item list-group-item-action" [ngClass]="(addToGroup && group.institutionID == addToGroup.groupID)?'active':''" (click)="selectGroup(group.institutionID, group.institutionName)" *ngFor="let group of groupList | search:searchTextGroup:['institutionName']; let i = index">{{group.institutionName}}</a>
            <div class="alert alert-warning" role="alert" *ngIf="groupList && ((groupList | search:searchTextGroup :['institutionName'] ).length == 0)">{{ translationKeys.Dashboard.NoDataFound | translate }}</div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-cancel-bordered-bd mr-4" aria-label="Close" (click)="modalRef.hide()">{{ translationKeys.Authorization.Cancel | translate }}</button>
                    <button type="button" class="btn btn-continue-bordered-bd" data-dismiss="modal" (click)="openstack(stackmodal)">{{ translationKeys.Authorization.Done | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #stackmodal class="modal-confirm">
    <div class="mb-4 modal-header  justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar>
        <p class="lead">
            {{ 'INSTITUTION_MANAGEMENT.INFORMATION_ADD_INSTITUTION_TO_GROUP' | translate }}
        </p>
        <p class="lead">{{ 'INSTITUTION_MANAGEMENT.QUESTION_WANT_CONTINUE' | translate }}</p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button type="button" class="btn-cancel-bordered-bd separate-buttons" data-dismiss="modal" (click)="modalRef.hide()">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button type="button" class="btn-bd-empty" data-dismiss="modal" (click)="updateGroupId()">{{ 'CONFIGURE.ADD' | translate }}</button>
        </div>
    </div>
</ng-template>


<ng-template #delmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
        <p> {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="delete();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #ungroupmodal class="modal-confirm">
    <div class="mb-4 modal-header  justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar>
        <p class="lead">
            {{ 'INSTITUTION_MANAGEMENT.INFORMATION_REMOVE_INSTITUTION_FROM_GROUP' | translate }}
        </p>
        <p class="lead">{{ 'INSTITUTION_MANAGEMENT.QUESTION_WANT_CONTINUE' | translate }}</p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button type="button" class="btn-cancel-bordered-bd separate-buttons" data-dismiss="modal" (click)="modalRef.hide()">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button type="button" class="btn-bd-empty" data-dismiss="modal" (click)="removeGroupId()">{{ 'INSTITUTION_MANAGEMENT.REMOVE' | translate }}</button>
        </div>
    </div>
</ng-template>

<div class="side-appbar">
    <div class="container-fluid"></div>
</div>

<div id="page_overlay"></div>